import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";

export default function NotFound() {
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: "100vh",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h4" component="h2" gutterBottom fontWeight="bold">
        Not Found Page
      </Typography>
      <Typography variant="h6" component="h3">
        ログインは
        <Link component={RouterLink} to="/" sx={{ mx: 0.5 }}>
          こちら
        </Link>
        から
      </Typography>
    </Box>
  );
}